/**
 * @fileoverview Servicio para gestión del LocalStorage de la póliza
 * @description Maneja la persistencia de datos de póliza en el navegador
 */

import { ICreatePoliza } from '../types';

const POLIZA_STORAGE_KEY = 'cg-seguros-poliza';

/**
 * Servicio para gestión del LocalStorage de la póliza
 */
export const polizaStorage = {
  /**
   * Guarda los datos de la póliza en LocalStorage
   * @param poliza - Datos de la póliza a guardar
   */
  savePoliza(poliza: ICreatePoliza): void {
    try {
      localStorage.setItem(POLIZA_STORAGE_KEY, JSON.stringify(poliza));
    } catch (error) {
      // Silently fail if localStorage is not available
    }
  },

  /**
   * Obtiene los datos de la póliza desde LocalStorage
   * @returns Datos de la póliza o null si no existen
   */
  getPoliza(): ICreatePoliza | null {
    try {
      const stored = localStorage.getItem(POLIZA_STORAGE_KEY);
      if (stored) {
        return JSON.parse(stored);
      }
      return null;
    } catch (error) {
      return null;
    }
  },

  /**
   * Limpia los datos de la póliza del LocalStorage
   */
  clearPoliza(): void {
    try {
      localStorage.removeItem(POLIZA_STORAGE_KEY);
    } catch (error) {
      // Silently fail if localStorage is not available
    }
  },

  /**
   * Verifica si existe una póliza guardada
   * @returns true si existe una póliza guardada
   */
  hasPoliza(): boolean {
    return this.getPoliza() !== null;
  }
};

